module.exports = __webpack_public_path__ + "img/horizontal_4_7_pp1_8017.dd9fb375.png";